// Copyright © 2025 CATTLEytics Inc.

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { AutoSizer, Column, Table } from 'react-virtualized';

export function VirtualizedBootstrapTable({ data }: { data: any[] }): JSX.Element {
  const columns = Object.keys(data[0] || {}).map((key) => ({
    dataKey: key,
    label: key,
    // className: `border-bottom`, // Align text to the end
    // width: 50, // Adjust width as needed
  }));
  return (
    <AutoSizer defaultWidth={1900} disableHeight doNotBailOutOnEmptyChildren>
      {({ width }): JSX.Element => (
        <Table
          gridClassName="m-0 table border"
          headerClassName="text-truncate"
          headerHeight={40}
          height={400}
          key="virtualized-table"
          rowClassName={'border-bottom border-right'}
          rowCount={data.length}
          rowGetter={({ index }): any => data[index]}
          rowHeight={50}
          width={width}
        >
          {columns.map((col) => (
            <Column
              className={'border-end text-truncate'}
              // cellRenderer={({ cellData }): JSX.Element => (
              //   <Col className="border-end text-truncate">{cellData}</Col>
              // )}
              dataKey={col.dataKey}
              key={col.dataKey}
              label={col.label}
              width={200} // Distribute width evenly - flex basis
            />
          ))}
        </Table>
      )}
    </AutoSizer>
  );
}
